import type { LocationVideoCage } from './locationVideoStore';

export interface StreamBannerState {
    /** A pen this user selected has not started streaming yet. */
    showSpinner: boolean;
    /** Nothing to watch: the empty grid explains how live video works. */
    showHello: boolean;
}

/** Which banner the video page shows, counting only online pens with quota left. */
type BannerCage = Pick<
    LocationVideoCage,
    'online' | 'isOutOfQuota' | 'isButtonSelected' | 'muxData'
>;

export function streamBannerState(
    activeCages: BannerCage[],
    onlyViewMode: boolean
): StreamBannerState {
    const showSpinner: boolean = activeCages
        .filter((cage) => cage.online && !cage.isOutOfQuota)
        .some((cage) => cage.isButtonSelected && cage.muxData?.status !== 'active');

    let showHello: boolean = activeCages
        .filter((cage) => cage.online && !cage.isOutOfQuota)
        .every((cage) => !cage.isButtonSelected);

    if (onlyViewMode) {
        showHello = !activeCages
            .filter((cage) => cage.online && !cage.isOutOfQuota)
            .some((cage) => cage.muxData?.status === 'active');
    }

    return { showSpinner, showHello };
}
